import React from "react";
import styles from "./scss/ServiceBox.module.scss"

const ServiceBox = ({ image, name, description }) => {
  return (
    <div className={styles.serviceBox}>
      <img src={image} alt=""  height="40%" className={styles.serviceBoximage}/>
      <div className={styles.content}>
        <h3>{name}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ServiceBox;
